import Base from './components/cells/Base';
import Loading from './components/cells/Loading';

export default function LoadingCell() {}

LoadingCell.prototype.init = function (params) {
    //Compared to other cells, this is rendered as a fullWidth cell, and ag-grid renders it
    //on another block outside w5-cell-container's div, thats why we create it here
    const loadingCellContainer = document.createElement('div');
    loadingCellContainer.classList.add('w5-cell-container');

    const loadingCell = Base(Loading(), params);
    loadingCellContainer.appendChild(loadingCell);

    this.eGui = loadingCellContainer;
};

LoadingCell.prototype.getGui = function () {
    return this.eGui;
};
